import { isObject } from '@mimir/primitive/type-guards/isObject';
import type TranscriptMarker from './transcriptMarker';

export default class LineBreakMarker implements TranscriptMarker {
  p: number;
  lineBreak: boolean;

  constructor(position: number) {
    this.p = position;
    this.lineBreak = true;
  }
}

export type LineBreakIndex = Record<number, boolean>;

export const isInstanceOfLineBreakMarker = (marker: any): marker is LineBreakMarker => {
  return isObject(marker) && 'lineBreak' in marker && 'p' in marker;
};
